import styled from "@emotion/styled";

import { transientOptions } from "shared/lib/styles/transient-options";

type Props = {
  $color: string;
  $size: string;
};
export const IconStyled = styled("span", { ...transientOptions })<Props>`
  inline-size: ${props => props.$size};
  block-size: ${props => props.$size};

  color: ${props => props.$color};

  /* Prevent the priority is lower than the class material-icons in dev */
  font-size: ${props => props.$size} !important;
`;
